import axios from "axios";
import React, { useCallback } from "react";
import { GoDownload } from "react-icons/go";
import { toast } from "react-toastify";
import { MediaFooterContainer } from "../styled/common";

const MediaFooter = ({ item, index, mediaInfos, onDownload }) => {
  return (
    <MediaFooterContainer>
      <div className="info">
        {mediaInfos(item, index).map(({ key, label, value }) => (
          <div className={key} key={key}>
            <span>{label}</span>
            <span>{value}</span>
          </div>
        ))}
      </div>
      <button onClick={onDownload}>
        <GoDownload />
        <span>저장</span>
      </button>
    </MediaFooterContainer>
  );
};

export default MediaFooter;
